import { useState } from "react"
import { FaFile, FaTrash } from "react-icons/fa"

import { FiTrash, FiUpload } from "react-icons/fi"
import Button from "./Button"
import { LuAudioLines } from "react-icons/lu"

export default function FilePicker({preview, type, className, onChange, accept = '*/*', label = '', icon, disabled = false}) {
    const [previewUrl, setPreviewUrl] = useState(preview || '')
    const [fileName, setFileName] = useState('')
    const [fileType, setFileType] = useState(type || '')
    
    const handleFileSelect = (e) => {
        const file = e.target.files[0]
        if (!file) return

        if (file.type.startsWith('image') || file.type.startsWith('video') || file.type.startsWith('audio')) {
            const preview = URL.createObjectURL(file)
            setPreviewUrl(preview)    
        }else{
            setPreviewUrl('')
        }

        setFileName(file.name)
        setFileType(file.type.split('/')[0])
        if(onChange) onChange(file)
    }

    const clearSelection = () => {
        setPreviewUrl('')
        setFileName('')
        setFileType('')
        if(onChange) onChange(null)
    }

    return (
        <div className={`flex group relative bg-input border rounded-md overflow-hidden ${className}`}>
            <input type="file" id='file-picker' className="hidden" onChange={handleFileSelect} accept={accept} />
            {(previewUrl && fileType==='image') && <img src={previewUrl} alt={fileName} decoding="async" style={{position:'absolute',width:'100%',height:'100%',objectFit:'cover'}} className='object-cover' />}
            {(previewUrl && fileType==='video') && <video src={previewUrl} controls className='w-full h-full object-cover' />}
            {(previewUrl && fileType==='audio') && <audio src={previewUrl} controls className="w-full h-full" />}
            {!previewUrl &&
                <div className='flex flex-col items-center text-secondary-foreground justify-center w-full h-full p-2 gap-2'>
                    <span className='text-xs break-all'>{fileName}</span>
                </div>
            }

            {!disabled && <div htmlFor='file-picker' className='absolute pointer-events-none bg-gradient-to-b from-black/70 to-transparent top-0 left-0 w-full h-full hidden justify-center items-center gap-2 group-hover:flex'>
                {(!fileName && !previewUrl) && <label htmlFor='file-picker' className='flex gap-2 items-center text-sm pointer-events-auto cursor-pointer'>
                    <FiUpload className="w-5 h-5" />
                    <span>Pick a file</span>
                </label>}
                {(fileName || previewUrl) && <Button className='absolute top-1 right-1 pointer-events-auto' type='danger' icon={<FiTrash className="w-3 h-3" />} onClick={clearSelection} />}
            </div>}
            
        </div>
    )
}